module.exports = __webpack_public_path__ + "img/profile.29f380f6.svg";